import { MapTo } from '@adobe/aem-react-editable-components';
import LandingHero, { LandingHeroEditConfig } from './LandingHero';

export default MapTo('cob-corp-acquisition/components/creditonebank/landing-hero')(LandingHero, LandingHeroEditConfig);